// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"98":"66d0b607c696fb79","2888":"5af564864d18eadd","3077":"66d0b607c696fb79","4674":"5127ebc978e83226","7812":"5127ebc978e83226"}[chunkId] + ".css";
};